module.exports = __webpack_public_path__ + "static/media/kalyan.30185bd1.png";